export default {
  HOME2_TITLE: "home2Title",
  HOME2_SUB_TITLE: "home2SubTitle",
  HOME2: "home2",
  HOME2_CONTENT: "home2Content",
  HOME3: "home3",
  HOME3_TITLE: "home3Title",
  HOME3_CONTENT: "home3Content",
  HOME4: "home4",
  HOME4_CONTENT: "home4Content",
  HOME5: "home5",
  HOME6: "home6",
  PROD_ONE1_TITLE: "prod_one1Title",
  PROD_ONE1_SUB_TITLE: "prod_one1SubTitle",
  PROD_ONE1_IMAGE: "prod_one1Image",
  PROD_ONE1: "prod_one1",
  PROD_ONE2: "prod_one2",
  PROD_ONE3: "prod_one3",
  PROD_ONE4: "prod_one4",
  PROD_ONE5: "prod_one5",
  PROD_ONE6: "prod_one6",
  PROD_ONE7: "prod_one7",
  PROD_TWO1_TITLE: "prod_two1Title",
  PROD_TWO1_SUB_TITLE: "prod_two1SubTitle",
  PROD_TWO1_IMAGE: "prod_two1Image",
  PROD_TWO1: "prod_two1",
  PROD_TWO2: "prod_two2",
  PROD_TWO3: "prod_two3",
  PROD_TWO4: "prod_two4",
  PROD_TWO5: "prod_two5",
  PROD_TWO6: "prod_two6",
  PROD_THREE1: "prod_three1",
  PROD_THREE1_TITLE: "prod_three1Title",
  PROD_THREE1_SUB_TITLE: "prod_three1SubTitle",
  PROD_THREE1_IMAGE: "prod_three1Image",
  PROD_THREE2: "prod_three2",
  PROD_THREE3: "prod_three3",
  PROD_THREE3_TITLE: "prod_three3Title",
  PROD_THREE3_SUB_TITLE: "prod_three3SubTitle",
  PROD_THREE3_IMAGE: "prod_three3Image",
  PROD_THREE4: "prod_three4",
  PROD_THREE5: "prod_three5",
  PROD_FOUR1: "prod_four1",
  PROD_FOUR1_TITLE: "prod_four1Title",
  PROD_FOUR1_SUB_TITLE: "prod_four1SubTitle",
  PROD_FOUR1_IMAGE: "prod_four1Image",
  PROD_FOUR2: "prod_four2",
  PROD_FOUR3: "prod_four3",
  PROD_FOUR4: "prod_four4",
  THREENAV1_TITLE: "threenav1Title",
  THREENAV1_IMAGE: "threenav1Image",
  THREENAV1: "threenav1",
  THREENAV2: "threenav2",
  THREENAV3: "threenav3",
  THREENAV4: "threenav4",
  THREENAV5: "threenav5",
  FIVENAV_ONE1_TITLE: "fivenav_one1Title",
  FIVENAV_ONE1_IMAGE: "fivenav_one1Image",
  FIVENAV_ONE1: "fivenav_one1",
  FIVENAV_ONE2: "fivenav_one2",
  FIVENAV_ONE3: "fivenav_one3",
  FIVENAV_ONE4: "fivenav_one4",
  FIVENAV_ONE5: "fivenav_one5",
  FIVENAV_ONE6: "fivenav_one6",
  FIVENAV_TWO1: "fivenav_two1",
  FIVENAV_TWO2: "fivenav_two2",
  HOME4_TITLE4: "home4Title4",
  HOME4_TITLE4_CONTENT: "home4Title4Content",
  EUROPE_LINE: "europe_line",
  EUROPE_LINE_TITLE: "europe_line_title",
  EUROPE_LINE_SUB_TITLE: "europe_line_sub_title",
  EUROPE_LINE_ROUTE_IMAGES: "europe_line_route_images"
};
